<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="crmFiltrosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Filtros
                            <span class="badge badge-secondary ml-2" v-if="id_fila">#{{ id_fila }}</span>
                            <span class="small text-muted ml-2" v-if="$store.state.user && ( $store.state.user.id_usuario == 1 )">{{ model_type }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="fila">
                            <filtro-model v-model="item.filtros" :validate="validate" :opcoes="lista_opcoes_filtro" />
                        </template>

                        <div class="list-group mt-3" v-if="lista_filtros && lista_filtros.length">
                            <li class="list-group-item d-flex justify-content-between" v-for="(filtro, ifx) in lista_filtros" :key="ifx">
                                <span>
                                    <a href="#" @click.prevent="selecionar_filtro(filtro)" class="card-link">{{ filtro.search }}</a>
                                </span>
                                <span>
                                    #{{ filtro.id_filtro_salvo }}
                                    <a href="#" @click.prevent="remover_filtro(filtro, ifx)" class="card-link text-danger ml-2" title="Remover Filtro">
                                        <i class="fa fa-times" aria-hidden="true"></i>
                                    </a>
                                </span>
                                
                            </li>
                        </div>

                        <br><br><br><br><br><br><br><br>

                        <div class="input-group input-group-sm" v-if="model_type && item && item.filtros && item.filtros.length">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <input type="checkbox" aria-label="Checkbox for following text input" v-model="ind_salvar">
                                </div>
                            </div>
                            <input type="text" class="form-control" aria-label="Text input with checkbox" v-if="!ind_salvar" disabled placeholder="Salvar Filtro">
                            <input type="text" class="form-control" aria-label="Text input with checkbox" v-else v-model="nome_filtro" placeholder="Nome do Filtro...">
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="atualizar()">Atualizar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import FiltroModel from '../../cadastros/shared/FiltroModel.vue';

export default {
    data() {
        return { 
            id_fila: null, 
            validate: false, 
            item: { 
                filtros: [],
                filas: [] 
            }, 
            ind_salvar: false, 
            nome_filtro: "", 
            lista_filtros: null, 
        }
    },

    components: { 
        FiltroModel,
    },

    props: ['model_type'], 

    computed: { 
        lista_opcoes_filtro: function () { 

            let opcoes; 

            if ( this.model_type == 'NPS' ) { 
                return [                                
                    /*
                    {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                    {id:'App\\azure\\procedimentoGrupo', search:'Grupo do Procedimento', service: 'procedimento_grupos.index'}, 
                    {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'},
                    {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                    {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                    {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
                    {id:'App\\azure\\unidadeOperacao', search:'Unidade', service:'unidade_operacaos.index'}, 
                    */
                    {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                    {id:'App\\azure\\usuario', search:'Usuário', service:'usuarios.index', parms: { perfil: 4, ativos: true }}, 
                ];
            }

            if ( this.model_type == 'App\\azure\\estoqueItem' ) { 
                return [                                
                    {id:'tag-estoque-item', search:'Classificação do Item do Estoque', service: 'estoque_items.index', parms: { ativos: true }, tag: true},    
                    {id:'App\\azure\\estoqueGrupo', search:'Grupo de Item do Estoque', service: 'estoque_grupos.index'}, 
                    {id:'App\\azure\\estoqueItem', search:'Item de Estoque', service: 'estoque_items.index'},  
                    //{id:'App\\azure\\estoqueLocal', search:'Local de Estoque', service: 'estoque_locals.index'},     
                    //{id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'}, 
                ];
            }

            opcoes = [                                
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'}, 
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'}, 
                {id:'App\\azure\\procedimentoGrupo', search:'Grupo do Procedimento', service: 'procedimento_grupos.index'}, 
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true}, 
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
                {id:'App\\azure\\medico', search:'Prestador', service: 'medicos.index'},
            ];
            
            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) { 
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }

            if ( this.model_type == 'App\\azure\\guia' ) { 
                opcoes.push({id:'App\\azure\\apoiado', search:'Apoiado', service:'apoiados.index'});
                opcoes.push({id:'App\\azure\\apoiadoOrigem', search:'Apoiado - Origem', service:'apoiado_origens.index', parms: { lista_filtro: true }});
            }

            if ( this.model_type == 'App\\azure\\receita' ) { 
                opcoes.push({id:'App\\azure\\medicamento', search:'Medicamento',service:'medicamentos.index', parms: { pep: true }});
                opcoes.push({id:'tag-medicamento', search:'Classificação do Medicamento', service: 'medicamentos.index', parms: { pep: true }, tag: true});
            }

            if ( this.model_type == 'cancelados' ) { 
                opcoes.push({id:'App\\azure\\motivo', search:'Motivo de Cancelamento',service:'motivos.index', parms: { tipo: 'atp'}});
            }

            if ( this.model_type == 'App\\azure\\atendimento' ) { 
                opcoes.push({id:'App\\azure\\apoiado', search:'Apoiado',service:'apoiados.index'});
            }

            if ( this.model_type == 'App\\azure\\laudo' ) { 
                opcoes.push({id:'tag-procedimento', search:'Classificação do Procedimento', service: 'procedimentos.index', parms: { ativos: true }, tag: true});
                opcoes.push({id:'App\\azure\\statusLaudo', search:'Status do Laudo', service: 'status_laudos.index'});
                opcoes.push({id:'App\\azure\\sinalizadorAtendimento', search:'Sinalizador de Atendimento', service: 'sinalizadores.index', parms: { ativos: 1 }});
                opcoes.push({id:'App\\azure\\apoiado', search:'Apoiado', service: 'apoiados.index'});
                opcoes.push({id:'App\\azure\\apoiadoOrigem', search:'Apoiado - Origem', service:'apoiado_origens.index', parms: { lista_filtro: true }});
            }
            
            return _.orderBy(opcoes, 'search');
        },

        fila: function () { 
            if ( !this.item.filas[this.id_fila] ) { 
                return; 
            }

            return this.item.filas[this.id_fila];
        }
    }, 

    methods: { 
        remover_filtro (filtro) { 

            if ( !confirm('Confirma remover o filtro: ' + filtro.st_titulo + '?') ) { 
                return; 
            }

            this.$util.atualizar (this, { 
                service: 'filtro_salvos',
                func: 'toggle', 
                dados: { 
                    id_filtro_salvo: filtro.id_filtro_salvo,
                },
                callback: () => { 
                    this.carregar_filtros();
                }
            });

        },

        selecionar_filtro (filtro) { 
            this.item.filtros = _.cloneDeep(filtro.filtros);
        },

        get_filtros (id_fila) { 
            return this.item.filas[id_fila]
                ? this.item.filas[id_fila].filtros.filter(f => !f.excluido)
                : []; 
        },

        atualizar () { 

            this.validate = true;

            this.$nextTick(() => {

                let invalids = $("#crmFiltrosModal .invalid");

                if (invalids.length && $(".invalid").is(":visible")) {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                    return; 
                }

                this.$set(this.item.filas, this.id_fila, { filtros: this.item.filtros });

                if ( this.ind_salvar ) { 
                    this.$util.atualizar (this, { 
                        service: 'filtro_salvos',
                        func: 'store', 
                        dados: { 
                            st_titulo: this.nome_filtro,
                            st_model_type: this.model_type,
                            fl_pessoal: true, 
                            fl_ativo: true, 
                            id_usuario: this.$store.state.user.id_usuario,
                            filtros: this.item.filtros,
                        }
                    });
                }

                $('#crmFiltrosModal').modal('hide');

                this.$emit('refresh');

            });

        },

        carregar_filtros() { 
            this.$util.load (this, { 
                service: 'filtro_salvos',
                func: 'index', 
                parms: { 
                    st_model_type: this.model_type,
                },
                loadTo: (res) => { 
                    this.lista_filtros = res;
                }
            });
        },

        abrir(id_fila) { 
            if ( this.lista_filtros === null ) { 
                this.carregar_filtros();
            }
            
            this.ind_salvar = false; 
            this.nome_filtro = '';
            this.validate = false;
            this.id_fila = id_fila; 

            if ( !this.item.filas[this.id_fila] ) { 
                this.$set(this.item.filas, this.id_fila, { filtros: [] });
            }

            this.item.filtros = this.item.filas[this.id_fila].filtros;

            $('#crmFiltrosModal').modal('show');
        }
    }
}
</script>
